// Maß-Labels als DOM-Overlay: scharfer Text, CSS-Styling, kein Font-Atlas.
// Anker: Mittelpunkte der drei lokalen Halbachsen des selektierten Quaders.
import * as THREE from "three"

// Stärke (S) bewusst ohne 3D-Label — sie steht im Details-Panel
export const PART_LABELS = [
  { key: "L", axis: new THREE.Vector3(1, 0, 0), scaleIndex: "x" },
  { key: "B", axis: new THREE.Vector3(0, 0, 1), scaleIndex: "z" }
]
// Gesamtmaß in Weltachsen: Breite/Höhe/Tiefe
export const BOUNDS_LABELS = [
  { key: "B", axis: new THREE.Vector3(1, 0, 0), scaleIndex: "x" },
  { key: "H", axis: new THREE.Vector3(0, 1, 0), scaleIndex: "y" },
  { key: "T", axis: new THREE.Vector3(0, 0, 1), scaleIndex: "z" }
]
const MARGIN_MM = 60

export default class DimensionOverlay {
  constructor(container, labelSpecs = PART_LABELS, colorClass = "text-amber-300") {
    this.container = container
    this.labelSpecs = labelSpecs
    this.labels = labelSpecs.map(({ key }) => {
      const el = document.createElement("div")
      el.className = "absolute hidden -translate-x-1/2 -translate-y-1/2 rounded-md bg-stone-900/80 " +
        `${colorClass} text-xs font-mono px-1.5 py-0.5 pointer-events-none whitespace-nowrap`
      el.dataset.dimension = key
      container.appendChild(el)
      return el
    })
    this.anchor = new THREE.Vector3()
  }

  update(mesh, camera, canvas) {
    const rect = canvas.getBoundingClientRect()
    this.labelSpecs.forEach(({ key, axis, scaleIndex }, i) => {
      const el = this.labels[i]
      const dims = mesh.userData.dims || { x: mesh.scale.x, y: mesh.scale.y, z: mesh.scale.z }
      const halfExtent = dims[scaleIndex] / 2
      this.anchor.copy(axis).multiplyScalar(halfExtent + MARGIN_MM)
        .applyQuaternion(mesh.quaternion).add(mesh.position)
        .project(camera)

      if (this.anchor.z > 1) { el.classList.add("hidden"); return }
      el.classList.remove("hidden")
      el.textContent = `${key} ${Math.round(dims[scaleIndex])}`
      el.style.left = `${(this.anchor.x * 0.5 + 0.5) * rect.width}px`
      el.style.top = `${(-this.anchor.y * 0.5 + 0.5) * rect.height}px`
    })
  }

  hide() {
    this.labels.forEach((el) => el.classList.add("hidden"))
  }

  dispose() {
    this.labels.forEach((el) => el.remove())
  }
}
